module.exports = __webpack_public_path__ + "img/pro_bg1.cbb39352.jpg";